import type { ReactNode } from 'react'
import { ExtensionsPanel } from '../panels/ExtensionsPanel'
import { MyCallsPanel } from '../panels/MyCallsPanel'
import { QueueDetailPanel } from '../panels/QueueDetailPanel'
import { ParkedCallsPanel } from '../panels/ParkedCallsPanel'
import { QueuesPanel } from '../panels/QueuesPanel'
import { VoicemailPanel } from '../panels/VoicemailPanel'
import { ContactsPanel } from '../panels/ContactsPanel'
import { CallHistoryPanel } from '../panels/CallHistoryPanel'

export interface PanelDef { id: string; title: string; render: () => ReactNode }

// The Phase-1 panel set, mirrored 1:1 from the legacy MainForm DockPanels.
// Deferred panes (Chat, Wallboard, History/CallLog) slot in here later.
export const PANELS: PanelDef[] = [
  { id: 'extensions', title: 'Extensions', render: () => <ExtensionsPanel /> },
  { id: 'mycalls', title: 'My calls', render: () => <MyCallsPanel /> },
  { id: 'queuedetail', title: 'Queue detail', render: () => <QueueDetailPanel /> },
  { id: 'parked', title: 'Parked', render: () => <ParkedCallsPanel /> },
  { id: 'queues', title: 'Queues', render: () => <QueuesPanel /> },
  { id: 'voicemail', title: 'Voicemail', render: () => <VoicemailPanel /> },
  { id: 'contacts', title: 'Contacts', render: () => <ContactsPanel /> },
  { id: 'history', title: 'Call history', render: () => <CallHistoryPanel /> }
]

export const PANEL_BY_ID = new Map(PANELS.map((p) => [p.id, p]))

// Dockview component map: each panel id -> a component (props ignored; panels read state
// from the TelephonyProvider context).
export const dockviewComponents = Object.fromEntries(
  PANELS.map((p) => [p.id, () => <>{p.render()}</>])
) as Record<string, () => JSX.Element>
